<script setup lang="ts"></script>

<template>
  <div class="flex flex-col gap-2 bg-white rounded-b-xl">
    <div class="bg-brown rounded-t-xl text-center py-2">
      <slot name="card-title"> Card Title </slot>
    </div>
    <div class="flex flex-col gap-1 px-4 md:px-8 py-4">
      <slot name="card-content"></slot>
    </div>
  </div>
</template>
